import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const MyInvestments = lazy(() => import('../../container/investor/investment/MyInvestments'));
const InvestmentDetails = lazy(() => import('../../container/investor/investment/InvestmentDetail/investmentDetails'));
const InvestmentUpdate = lazy(() => import('../../container/investor/investment/investmentUpdate'));
const InvestmentCreate = lazy(() => import('../../container/investor/investment/investmentCreate'));
const InvestmentOpportunities = lazy(() => import('../../container/investor/investment/InvestmentOpportunities'));

function Investments() {
  return (
    <Routes>
      <Route path="portfolio" element={<MyInvestments />} />
      <Route path="opportunities" element={<InvestmentOpportunities />} />
      <Route path="create/:id" element={<InvestmentCreate />} />
      <Route path="detail/:id" element={<InvestmentDetails />} />
      <Route path="update/:id" element={<InvestmentUpdate />} />
    </Routes>
  );
}

export default Investments;
